<template>
    <div class="stock_record">
        <div class="record_header">
            <div class="back_btn" @click="$router.back()">
                <van-icon name="arrow-left" size="24" />
            </div>
            <span class="record_title">出入库记录</span>
            <div class="header_filter" @click="showFilter = true">
                <van-icon name="filter-o" size="24" />
            </div>
        </div>



        <!-- 记录列表 -->
        <van-tabs v-model="activeTab" sticky @change="onTabChange">
            <van-tab title="全部" name="all"></van-tab>
            <van-tab title="产品" name="product"></van-tab>
            <van-tab title="物料" name="material"></van-tab>
        </van-tabs>

        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" loading-text="加载中..." @load="onLoad"
                :immediate-check="false">
                <div class="record_list">
                    <div class="record_item" v-for="item in list" :key="item.id" @click="showDetail(item)">
                        <div class="record_left" >
                            <div class="type_tag" :class="item.in_out">
                                {{ item.in_out === 'in' ? '入库' : '出库' }}
                            </div>
                            <div class="record_info">
                                <div class="record_title">
                                    <span class="name">{{ item.record_name || item.apply_type + '-' +
                                        item.record_id }}</span>
                                    <van-tag :type="item.apply_type === 'product' ? 'primary' : 'success'" size="small">
                                        {{ item.apply_type === 'product' ? '产品' : '物料' }}
                                    </van-tag>
                                </div>
                                <div class="record_meta">
                                    <span>{{ item.create_time | formatTime }}</span>
                                    <span class="divider">|</span>
                                    <span>申请人: {{ item.apply_user_name || '-' }}</span>
                                </div>
                                <!-- <div class="record_remark" v-if="item.remark">备注: {{ item.remark }}</div> -->
                            </div>
                        </div>
                        <div class="record_right">
                            <div class="record_num" :class="item.in_out">
                                {{ item.in_out === 'in' ? '+' : '-' }}{{ item.apply_num }}
                            </div>
                            <div class="record_status" :class="item.sure_user_id ? 'status_1' : 'status_0'">
                                {{ item.sure_user_id ? '已确认' : '待确认' }}
                            </div>

                        </div>
                        <!-- 操作按钮 -->
                        <div class="item_actions">
                            <van-button
                                v-if="!item.sure_user_id && canConfirm(item)"
                                type="primary"
                                size="mini"
                                @click.stop="confirmStock(item)"
                            >
                                确认
                            </van-button>
                            <van-button size="mini" @click.stop="editItem(item)">编辑</van-button>
                            <van-button size="mini" type="danger" @click.stop="deleteItem(item)">删除</van-button>
                        </div>
                    </div>

                </div>
            </van-list>
        </van-pull-refresh>

        <!-- 筛选弹窗 -->
        <van-popup v-model="showFilter" position="right" style="width: 80%; height: 100%;">
            <div class="filter_panel">
                <div class="filter_header">
                    <span>筛选条件</span>
                    <van-icon name="cross" @click="showFilter = false" size="24" />
                </div>

                <div class="filter_body">
                    <div class="filter_section">
                        <div class="filter_title">应用</div>
                        <van-field v-model="filter.studio_name" type="select" placeholder="请选择应用" readonly
                            @click="showStudioSelect = true" class="filter_field">
                            <template v-if="filter.studio_name">#{{ filter.studio_id }} {{ filter.studio_name
                            }}</template>
                        </van-field>
                    </div>

                    <div class="filter_section">
                        <div class="filter_title">销售人员</div>
                        <van-field v-model="filter.sale_user_name" type="select" placeholder="请选择销售人员" readonly
                            @click="showSaleUserSelect = true" class="filter_field">
                            <template v-if="filter.sale_user_name">{{ filter.sale_user_name }}</template>
                        </van-field>
                    </div>

                    <div class="filter_section">
                        <div class="filter_title">确认用户</div>
                        <van-field v-model="filter.confirm_user_name" type="select" placeholder="请选择确认用户" readonly
                            @click="showConfirmUserSelect = true" class="filter_field">
                            <template v-if="filter.confirm_user_name">{{ filter.confirm_user_name }}</template>
                        </van-field>
                    </div>
                </div>

                <div class="filter_footer">
                    <van-button type="default" block @click="resetFilter">重置</van-button>
                    <van-button type="primary" block @click="confirmFilter">确定</van-button>
                </div>
            </div>
        </van-popup>

        <!-- 应用选择器 -->
        <van-popup v-model="showStudioSelect" position="bottom" round>
            <van-picker ref="studioPicker" show-toolbar :columns="studioList" value-key="text"
                @confirm="onStudioConfirm" @cancel="showStudioSelect = false" />
        </van-popup>

        <!-- 销售人员选择器 -->
        <van-popup v-model="showSaleUserSelect" position="bottom" round>
            <van-picker ref="saleUserPicker" show-toolbar :columns="saleUserList" value-key="text"
                @confirm="onSaleUserConfirm" @cancel="showSaleUserSelect = false" />
        </van-popup>

        <!-- 确认用户选择器 -->
        <van-popup v-model="showConfirmUserSelect" position="bottom" round>
            <van-picker ref="confirmUserPicker" show-toolbar :columns="confirmUserList" value-key="text"
                @confirm="onConfirmUserConfirm" @cancel="showConfirmUserSelect = false" />
        </van-popup>

        <!-- 新增表单弹窗 -->
        <van-popup v-model="showAddForm" position="bottom" round>
            <div class="add_form_panel">
                <div class="form_header">
                    <span>新增出入库</span>
                    <van-icon name="cross" size="24" @click="showAddForm = false" />
                </div>
                <div class="form_body">
                    <van-form @submit="onSubmit">
                        <van-field v-model="formData.in_out_text" type="select" label="出入库" placeholder="请选择" readonly
                            @click="showInOutSelect = true" is-link required />
                        <van-field v-model="formData.apply_type_text" type="select" label="类型" placeholder="请选择"
                            readonly @click="showApplyTypeSelect = true" is-link required />
                        <van-field v-model="formData.record_name" type="select" label="名称" placeholder="请选择" readonly
                            @click="showRecordSelect = true" is-link v-if="formData.apply_type" required />
                        <van-field v-model="formData.studio_name" type="select" label="应用" placeholder="请选择（选填）" readonly
                            @click="onStudioSelect2Click" is-link />
                        <van-field v-if="formData.in_out === 'in' && formData.apply_type === 'product'" label="设备码方式">
                            <template #input>
                                <van-radio-group v-model="snInputMode" direction="horizontal" @change="onSnInputModeChange">
                                    <van-radio name="manual">手动填写</van-radio>
                                    <van-radio name="auto">系统生成</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <!-- 入库+产品：手动模式下SN必填，数量自动计算 -->
                        <van-field v-if="formData.in_out === 'in' && formData.apply_type === 'product' && snInputMode === 'manual'" v-model="formData.device_sns" type="textarea" rows="3" label="设备SN" :placeholder="'多个SN用英文逗号分隔，如: SN001,SN002,SN003'" required @input="onDeviceSnsInput" />
                        <van-notice-bar v-if="formData.in_out === 'in' && formData.apply_type === 'product' && snInputMode === 'auto'" color="#1989fa" background="#ecf9ff" left-icon="info-o">
                            系统将按数量生成全局唯一设备码
                        </van-notice-bar>
                        <!-- 出库设备选择 -->
                        <van-field v-if="formData.in_out === 'out' && formData.apply_type === 'product' && formData.record_id"
                            v-model="formData.device_sns_display" type="textarea" rows="2" label="选择设备"
                            :placeholder="'点击选择出库设备'" readonly @click="openDeviceSelector" is-link required />
                        <div class="selected_devices_hint" v-if="formData.in_out === 'out' && selectedDevices.length > 0">
                            已选 {{ selectedDevices.length }} 台设备
                        </div>
                        <van-field v-model="formData.apply_num" type="number" label="数量" :placeholder="getApplyNumPlaceholder()" clearable
                            required :readonly="isApplyNumReadonly()" />
                        <div class="stock_hint" v-if="currentStockNum > 0">
                            当前库存：{{ currentStockNum }}
                        </div>
                        <van-field v-model="formData.remark" type="textarea" rows="2" label="备注" placeholder="选填" />
                        <div class="submit_btn">
                            <van-button type="primary" native-type="submit" block round>
                                提交
                            </van-button>
                        </div>
                    </van-form>
                </div>
            </div>
        </van-popup>

        <!-- 出入库类型选择器 -->
        <van-popup v-model="showInOutSelect" position="bottom" round>
            <van-picker ref="inOutPicker" show-toolbar show-search :columns="inOutList" value-key="text"
                @confirm="onInOutConfirm" @cancel="showInOutSelect = false" />
        </van-popup>

        <!-- 产品类型选择器 -->
        <van-popup v-model="showApplyTypeSelect" position="bottom" round>
            <van-picker ref="applyTypePicker" show-toolbar show-search :columns="applyTypeList" value-key="text"
                @confirm="onApplyTypeConfirm" @cancel="showApplyTypeSelect = false" />
        </van-popup>

        <!-- 产品/物料选择器 -->
        <van-popup v-model="showRecordSelect" position="bottom" round>
            <div class="picker_with_search">
                <van-search v-model="recordSearchKey" placeholder="搜索" shape="round" @change="filterRecordList" />
                <van-picker ref="recordPicker" show-toolbar :columns="filteredRecordList" value-key="text"
                    @confirm="onRecordConfirm" @cancel="showRecordSelect = false" />
            </div>
        </van-popup>

        <!-- 应用选择器（表单用） -->
        <van-popup v-model="showStudioSelect2" position="bottom" round>
            <div class="picker_with_search">
                <van-search v-model="studioSearchKey" placeholder="搜索" shape="round" @change="filterStudioList" />
                <van-picker ref="studioPicker2" show-toolbar :columns="filteredStudioList" value-key="text"
                    @confirm="onStudioConfirm2" @cancel="showStudioSelect2 = false" />
            </div>
        </van-popup>

        <!-- 出库设备选择弹窗 -->
        <van-popup v-model="showDeviceSelector" position="bottom" round style="height: 85%;">
            <div class="device_selector_panel">
                <div class="form_header">
                    <span>选择设备</span>
                    <van-icon name="cross" size="24" @click="showDeviceSelector = false" />
                </div>
                <!-- 筛选区域 -->
                <div class="device_filter_area">
                    <van-field v-model="deviceFilter.device_sn" label="设备SN" placeholder="输入SN筛选" clearable @clear="searchDeviceList" />
                    <van-field v-model="deviceFilter.stock_in_time_text" label="入库时间" placeholder="选择入库时间" readonly is-link @click="showDeviceStockInDatePicker = true" />
                    <van-field v-model="deviceFilter.stock_out_time_text" label="出库时间" placeholder="选择出库时间" readonly is-link @click="showDeviceStockOutDatePicker = true" />
                    <div class="device_filter_btns">
                        <van-button size="small" @click="resetDeviceFilter">重置</van-button>
                        <van-button size="small" type="primary" @click="searchDeviceList">搜索</van-button>
                    </div>
                </div>
                <!-- 设备列表 -->
                <div class="device_list_area">
                    <van-pull-refresh v-model="deviceRefreshing" @refresh="onDeviceRefresh">
                        <van-list v-model="deviceLoading" :finished="deviceFinished" finished-text="没有更多了" @load="onDeviceLoad">
                            <van-checkbox-group v-model="selectedDeviceIds">
                                <van-cell-group>
                                    <van-cell v-for="device in deviceList" :key="device.id" :clickable="canSelectDevice(device)" @click="toggleDevice(device)" :class="{'device_disabled': !canSelectDevice(device)}">
                                        <template #title>
                                            <div class="device_cell_title">
                                                <span class="device_sn">{{ getSelectedDeviceText(device) }}</span>
                                                <span class="device_no_report" v-if="showDeviceReportMissing(device)">{{ "（报告不全）" }}</span>
                                            </div>
                                        </template>
                                        <template #label>
                                            <div class="device_cell_label">
                                                <span v-if="device.stock_in_time">入库: {{ device.stock_in_time | formatTime }}</span>
                                                <span v-if="device.stock_out_time"> | 出库: {{ device.stock_out_time | formatTime }}</span>
                                            </div>
                                            <!-- 报告显示区域（仅展示和下载，不上传） -->
                                            <div class="device_report_actions" @click.stop>
                                                <div class="report_row">
                                                    <span class="report_label">出厂报告:</span>
                                                    <template v-if="device.factory_report">
                                                        <span class="report_file_name">{{getFileName(device.factory_report)}}</span>
                                                        <van-button size="mini" type="primary" plain @click.stop="downloadReport(device.factory_report, '出厂报告')">下载</van-button>
                                                    </template>
                                                    <span v-else class="report_missing">未上传</span>
                                                </div>
                                                <div class="report_row">
                                                    <span class="report_label">出货报告:</span>
                                                    <template v-if="device.shipment_report">
                                                        <span class="report_file_name">{{getFileName(device.shipment_report)}}</span>
                                                        <van-button size="mini" type="primary" plain @click.stop="downloadReport(device.shipment_report, '出货报告')">下载</van-button>
                                                    </template>
                                                    <span v-else class="report_missing">未上传</span>
                                                </div>
                                            </div>
                                        </template>
                                        <template #right-icon>
                                            <van-checkbox :name="device.id" ref="deviceCheckboxes" :disabled="!canSelectDevice(device)" />
                                        </template>
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </van-list>
                    </van-pull-refresh>
                    <div class="device_list_empty" v-if="deviceList.length === 0 && !deviceLoading">
                        暂无设备数据
                    </div>
                </div>
                <div class="device_selector_footer">
                    <van-button type="primary" block round @click="confirmDeviceSelection">
                        确定 (已选{{ selectedDeviceIds.length }}台)
                    </van-button>
                </div>
            </div>
        </van-popup>

        <!-- 设备筛选 - 入库时间选择器 -->
        <van-popup v-model="showDeviceStockInDatePicker" position="bottom" round>
            <van-datetime-picker
                v-model="deviceFilter.stock_in_date"
                type="date"
                title="选择入库时间"
                @confirm="onDeviceStockInDateConfirm"
                @cancel="showDeviceStockInDatePicker = false"
            />
        </van-popup>

        <!-- 设备筛选 - 出库时间选择器 -->
        <van-popup v-model="showDeviceStockOutDatePicker" position="bottom" round>
            <van-datetime-picker
                v-model="deviceFilter.stock_out_date"
                type="date"
                title="选择出库时间"
                @confirm="onDeviceStockOutDateConfirm"
                @cancel="showDeviceStockOutDatePicker = false"
            />
        </van-popup>

        <!-- 新增按钮 -->
        <div class="add_btn" @click="showAddForm = true">
            <van-icon name="plus" color="#fff" size="28" />
        </div>

        <!-- 编辑表单弹窗 -->
        <van-popup v-model="showEditForm" position="bottom" round style="height: 80%;">
            <div class="add_form_panel">
                <div class="form_header">
                    <span>编辑出入库</span>
                    <van-icon name="cross" size="24" @click="showEditForm = false" />
                </div>
                <div class="form_body">
                    <van-form @submit="onEditSubmit">
                        <van-field
                            v-model="editForm.in_out_text"
                            label="出入库"
                            readonly
                        />
                        <van-field
                            v-model="editForm.apply_type_text"
                            type="select"
                            label="类型"
                            placeholder="请选择"
                            readonly
                            @click="showEditApplyTypeSelect = true"
                            is-link
                            required
                        />
                        <van-field
                            v-model="editForm.record_name"
                            type="select"
                            label="名称"
                            placeholder="请选择"
                            readonly
                            @click="showEditRecordSelect = true"
                            is-link
                            required
                        />
                        <van-field
                            v-model="editForm.studio_name"
                            type="select"
                            label="项目"
                            placeholder="请选择（选填）"
                            readonly
                            @click="showEditStudioSelect = true"
                            is-link
                        />
                        <van-field
                            v-model="editForm.apply_num"
                            type="number"
                            label="数量"
                            placeholder="请输入数量"
                            clearable
                            required
                        />
                        <van-field
                            v-model="editForm.remark"
                            type="textarea"
                            rows="2"
                            label="备注"
                            placeholder="选填"
                        />
                        <div class="submit_btn">
                            <van-button type="primary" native-type="submit" block round>
                                保存
                            </van-button>
                        </div>
                    </van-form>
                </div>
            </div>
        </van-popup>

        <!-- 编辑 - 产品类型选择器 -->
        <van-popup v-model="showEditApplyTypeSelect" position="bottom" round>
            <van-picker
                ref="editApplyTypePicker"
                show-toolbar
                :columns="applyTypeList"
                value-key="text"
                @confirm="onEditApplyTypeConfirm"
                @cancel="showEditApplyTypeSelect = false"
            />
        </van-popup>

        <!-- 编辑 - 产品/物料选择器 -->
        <van-popup v-model="showEditRecordSelect" position="bottom" round style="height: 70%;">
            <div class="picker_with_search">
                <van-search
                    v-model="editRecordSearchKey"
                    placeholder="搜索"
                    shape="round"
                    @change="filterEditRecordList"
                />
                <van-picker
                    ref="editRecordPicker"
                    show-toolbar
                    :columns="filteredRecordList"
                    value-key="text"
                    @confirm="onEditRecordConfirm"
                    @cancel="showEditRecordSelect = false"
                />
            </div>
        </van-popup>

        <!-- 编辑 - 项目选择器 -->
        <van-popup v-model="showEditStudioSelect" position="bottom" round style="height: 70%;">
            <div class="picker_with_search">
                <van-search
                    v-model="editStudioSearchKey"
                    placeholder="搜索"
                    shape="round"
                    @change="filterEditStudioList"
                />
                <van-picker
                    ref="editStudioPicker"
                    show-toolbar
                    :columns="filteredStudioList"
                    value-key="text"
                    @confirm="onEditStudioConfirm"
                    @cancel="showEditStudioSelect = false"
                />
            </div>
        </van-popup>

        <van-dialog v-model="generatedSnDialogVisible" title="系统生成的设备码" show-cancel-button
            confirm-button-text="复制全部" cancel-button-text="关闭" @confirm="copyGeneratedSns">
            <div class="generated_sn_result">
                <div class="generated_sn_tip">已生成 {{ generatedSns.length }} 个设备码并保存到入库申请</div>
                <van-field :value="generatedSns.join('\n')" type="textarea" rows="9" readonly autosize />
            </div>
        </van-dialog>

        <!-- 详情弹窗 -->
    </div>
</template>

<script>
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import until from '@/api/until.js'
import studio_tool_api from '@/api/teaching_studio_tool.js'
import { createProductStockApply } from '@/api/iotmax_stock_device_api.js'
import { getStoredIotmaxStock } from '@/utils/iotmaxStock.js'
export default {
    name: 'StockRecord',
    data() {
        return {
            activeTab: 'all',
            list: [],
            page: 1,
            each_page: 10,
            loading: false,
            finished: false,
            refreshing: false,
            isFetching: false,

            showFilter: false,

            // 新增表单相关
            showAddForm: false,
            showInOutSelect: false,
            showApplyTypeSelect: false,
            showRecordSelect: false,
            showStudioSelect2: false,

            // 编辑表单相关
            showEditForm: false,
            editItemId: null,
            showEditApplyTypeSelect: false,
            showEditRecordSelect: false,
            showEditStudioSelect: false,
            editRecordSearchKey: '',
            editStudioSearchKey: '',

            // 选项列表
            inOutList: [
                { text: '入库', value: 'in' },
                { text: '出库', value: 'out' }
            ],
            applyTypeList: [
                { text: '产品', value: 'product' },
                { text: '物料', value: 'material' }
            ],
            recordList: [],
            studioList: [],

            // 搜索相关
            recordSearchKey: '',
            studioSearchKey: '',
            filteredRecordList: [],
            filteredStudioList: [],

            // 当前库存数量
            currentStockNum: 0,
            currentWarehouse: getStoredIotmaxStock() || {
                stock_code: '',
                stock_name: ''
            },
            snInputMode: 'manual',
            generatedSnDialogVisible: false,
            generatedSns: [],

            // 选择器显示状态
            showStudioSelect: false,
            showSaleUserSelect: false,
            showConfirmUserSelect: false,

            // 选项列表
            studioList: [],
            saleUserList: [],
            confirmUserList: [],

            filter: {
                studio_id: '',
                studio_name: '',
                sale_user_id: '',
                sale_user_name: '',
                confirm_user_id: '',
                confirm_user_name: ''
            },

            // 表单数据
            formData: {
                in_out: '',
                in_out_text: '',
                apply_type: '',
                apply_type_text: '',
                studio_id: '',
                studio_name: '',
                record_id: '',
                record_name: '',
                apply_num: '',
                device_sns: '',
                device_sns_display: '',
                remark: ''
            },

            // 编辑相关
            showEditForm: false,
            editItemId: null,
            editForm: {
                in_out: '',
                in_out_text: '',
                apply_type: '',
                apply_type_text: '',
                studio_id: '',
                studio_name: '',
                record_id: '',
                record_name: '',
                apply_num: '',
                remark: ''
            },

            // 出库设备选择相关
            showDeviceSelector: false,
            deviceList: [],
            selectedDeviceIds: [],
            selectedDevices: [],
            deviceLoading: false,
            deviceIsFetching: false,
            deviceFinished: false,
            deviceRefreshing: false,
            devicePage: 1,
            devicePageSize: 20,
            showDeviceStockInDatePicker: false,
            showDeviceStockOutDatePicker: false,
            deviceFilter: {
                device_sn: '',
                stock_in_time: 0,
                stock_in_time_text: '',
                stock_in_date: new Date(),
                stock_out_time: 0,
                stock_out_time_text: '',
                stock_out_date: new Date()
            }
        }
    },
    filters: {
        formatTime(timestamp) {
            if (!timestamp) return '-'
            let date = new Date(timestamp * 1000)
            return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
        },

    },
    mounted() {
        this.refreshCurrentWarehouse()
        document.title = "出入库记录"
        this.getFilterOptions()
        this.loadData()
        console.log(this.$root.userInfo);
        console.log(this.$root.isSuperRoot);


    },
    methods: {
        refreshCurrentWarehouse() {
            this.currentWarehouse = getStoredIotmaxStock() || {
                stock_code: '',
                stock_name: ''
            }
        },
        isApplyNumReadonly() {
            if (this.formData.apply_type !== 'product') return false
            if (this.formData.in_out === 'in') return this.snInputMode === 'manual'
            return true
        },
        getApplyNumPlaceholder() {
            if (this.formData.apply_type !== 'product') return '请输入数量'
            if (this.formData.in_out === 'in' && this.snInputMode === 'auto') return '请输入需要生成的设备码数量'
            return '由设备SN自动计算'
        },
        shouldRequireDeviceReports() {
            return Number(this.currentWarehouse && this.currentWarehouse.stock_code || 0) === 1
        },
        canSelectDevice(device) {
            if (!this.shouldRequireDeviceReports()) return true
            return !!(device && device.factory_report && device.shipment_report)
        },
        showDeviceReportMissing(device) {
            return this.shouldRequireDeviceReports() && !this.canSelectDevice(device)
        },
        getSelectedDeviceText(device) {
            return (device && (device.device_sn || device.sn || device.serial_number || device.code)) || '-'
        },
        onSnInputModeChange() {
            this.formData.device_sns = ''
            this.formData.apply_num = ''
            this.resetSelectedDevices()
        },
        resetSelectedDevices() {
            this.selectedDeviceIds = []
            this.selectedDevices = []
            this.formData.device_sns = ''
            this.formData.device_sns_display = ''
            if (this.formData.in_out === 'out' && this.formData.apply_type === 'product') {
                this.formData.apply_num = ''
            }
        },
        // 获取筛选选项列表
        async getFilterOptions() {
            this.getStudioList()
            this.getSaleUserList()
            this.getConfirmUserList()
        },

        // 获取应用列表
        async getStudioList() {
            try {
                let res = await studio_api.Teaching_studio_apiStudioWechatStudioGet({
                    app_id: this.$root.app_id
                })
                if (res.errcode === 0 && res.other) {
                    let listData = Array.isArray(res.other) ? res.other : (res.other.list || [])
                    this.studioList = listData.map(item => ({
                        text: `#${item.id} ${item.name}`,
                        value: String(item.id)
                    }))
                }
            } catch (e) {
                console.error('获取应用列表失败', e)
            }
        },

        // 获取销售人员列表
        async getSaleUserList() {
            try {
                let res = await studio_api.Teaching_studio_apiIotmaxUsersGet({
                    app_id: this.$root.app_id
                })
                if (res.errcode === 0 && res.other) {
                    let listData = res.other.list || []
                    this.saleUserList = listData.map(item => ({
                        text: item.real_name || item.name,
                        value: String(item.user_id || item.id)
                    }))
                    this.confirmUserList = [...this.saleUserList]
                }
            } catch (e) {
                console.error('获取用户列表失败', e)
            }
        },

        // 获取确认用户列表（与销售人员相同）
        async getConfirmUserList() {
            // 已经在 getSaleUserList 中一起获取了
        },

        // 应用选择确认
        onStudioConfirm() {
            const picker = this.$refs.studioPicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.filter.studio_id = item.value
                    this.filter.studio_name = item.text.replace(/^#\d+\s*/, '')
                }
            }
            this.showStudioSelect = false
        },

        // 销售人员选择确认
        onSaleUserConfirm() {
            const picker = this.$refs.saleUserPicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.filter.sale_user_id = item.value
                    this.filter.sale_user_name = item.text
                }
            }
            this.showSaleUserSelect = false
        },

        // 确认用户选择确认
        onConfirmUserConfirm() {
            const picker = this.$refs.confirmUserPicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.filter.confirm_user_id = item.value
                    this.filter.confirm_user_name = item.text
                }
            }
            this.showConfirmUserSelect = false
        },

        // 加载数据（统一入口）
        async loadData() {
            if (this.isFetching) return
            this.isFetching = true
            this.loading = true

            try {
                let params = {
                    page: this.page,
                    each_page: this.each_page
                }

                // 类型筛选（产品/物料）
                if (this.activeTab !== 'all') {
                    params.apply_type = this.activeTab
                }

                // 应用筛选
                if (this.filter.studio_id) {
                    params.studio_id = this.filter.studio_id
                }

                // 销售人员筛选
                if (this.filter.sale_user_id) {
                    params.sale_user_id = this.filter.sale_user_id
                }

                // 确认用户筛选
                if (this.filter.confirm_user_id) {
                    params.confirm_user_id = this.filter.confirm_user_id
                }

                if (this.$route.query.id) {
                    params.record_id = this.$route.query.id
                    params.apply_type = this.$route.query.type
                }

                let data = await studio_api.Teaching_studio_apiIotmaxStock_out_applyListGet({ ...params, app_id: this.$root.app_id })

                if (data.errcode === 0) {
                    let originalList = data.other && data.other.list ? data.other.list : []
                    let list = [...originalList]

                    // 确认状态前端筛选（如果后端不支持）
                    if (this.filter.confirm_status === 'pending') {
                        list = list.filter(item => !item.sure_user_id)
                    } else if (this.filter.confirm_status === 'confirmed') {
                        list = list.filter(item => item.sure_user_id)
                    }

                    if (this.page === 1) {
                        this.list = list
                    } else {
                        // 去重，防止后端分页bug导致重复数据
                        let newItems = list.filter(item => !this.list.some(existing => existing.id === item.id))
                        this.list = this.list.concat(newItems)
                    }

                    // 使用原始数据的长度来判断是否还有下一页
                    if (originalList.length < this.each_page) {
                        this.finished = true
                    } else {
                        this.page = this.page + 1
                    }
                } else {
                    this.finished = true
                }
            } catch (error) {
                console.error('获取列表失败', error)
                this.finished = true
            } finally {
                this.$nextTick(() => {
                    this.isFetching = false
                    this.loading = false
                    this.refreshing = false
                })
            }
        },

        // 刷新
        onRefresh() {
            this.page = 1
            this.list = []
            this.finished = false
            this.loading = true
            this.loadData()
        },

        // 加载更多
        onLoad() {
            if (this.finished || this.isFetching) {
                this.loading = false
                return
            }
            this.loadData()
        },

        // Tab切换
        onTabChange() {
            this.page = 1
            this.list = []
            this.finished = false
            this.loading = false
            this.loadData()
        },

        // 重置筛选
        resetFilter() {
            this.filter = {
                studio_id: '',
                studio_name: '',
                sale_user_id: '',
                sale_user_name: '',
                confirm_user_id: '',
                confirm_user_name: ''
            }
        },

        // 确认筛选
        confirmFilter() {
            this.showFilter = false
            this.onRefresh()
        },

        // 出入库类型确认
        onInOutConfirm() {
            this.resetSelectedDevices()
            this.snInputMode = 'manual'
            this.formData.apply_num = ''
            const picker = this.$refs.inOutPicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.formData.in_out = item.value
                    this.formData.in_out_text = item.text
                }
            }
            this.showInOutSelect = false
        },

        // 产品类型点击
        onApplyTypeClick() {
            this.showApplyTypeSelect = true
        },

        // 产品类型确认
        onApplyTypeConfirm() {
            this.resetSelectedDevices()
            this.snInputMode = 'manual'
            this.formData.apply_num = ''
            const picker = this.$refs.applyTypePicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.formData.apply_type = item.value
                    this.formData.apply_type_text = item.text
                    this.formData.record_id = ''
                    this.formData.record_name = ''
                    this.recordList = []
                }
            }
            this.showApplyTypeSelect = false
            // 加载对应的产品或物料列表
            this.$nextTick(() => {
                this.getRecordList()
            })
        },

        // 获取产品/物料列表
        async getRecordList() {
            if (!this.formData.apply_type) return

            this.$toast.loading({ message: '加载中...', duration: 0 })

            try {
                let res
                if (this.formData.apply_type === 'product') {
                    res = await studio_api.Teaching_studio_apiIotmaxProductListGet({
                        app_id: this.$root.app_id,
                        page: 1,
                        each_page: 100
                    })
                } else {
                    res = await studio_api.Teaching_studio_apiIotmaxMaterialListGet({
                        app_id: this.$root.app_id,
                        page: 1,
                        each_page: 100
                    })
                }

                this.$toast.clear()

                if (res.errcode === 0 && res.other) {
                    let listData = res.other.list || []
                    this.recordList = listData.map(item => ({
                        text: item.name,
                        value: String(item.id)
                    }))
                    this.filteredRecordList = [...this.recordList]
                    this.recordSearchKey = ''
                    // 自动打开选择器
                    this.showRecordSelect = true
                }
            } catch (e) {
                this.$toast.clear()
                console.error('获取列表失败', e)
                this.$toast('获取列表失败')
            }
        },

        // 过滤产品/物料列表
        filterRecordList() {
            if (!this.recordSearchKey) {
                this.filteredRecordList = [...this.recordList]
            } else {
                const key = this.recordSearchKey.toLowerCase()
                this.filteredRecordList = this.recordList.filter(item =>
                    item.text.toLowerCase().includes(key)
                )
            }
        },

        // 过滤应用列表
        filterStudioList() {
            if (!this.studioSearchKey) {
                this.filteredStudioList = [...this.studioList]
            } else {
                const key = this.studioSearchKey.toLowerCase()
                this.filteredStudioList = this.studioList.filter(item =>
                    item.text.toLowerCase().includes(key) ||
                    item.value.toLowerCase().includes(key)
                )
            }
        },

        // 产品/物料选择确认
        onRecordConfirm() {
            this.resetSelectedDevices()
            const picker = this.$refs.recordPicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.formData.record_id = item.value
                    this.formData.record_name = item.text
                    // 获取库存数量
                    this.getStockNum()
                }
            }
            this.showRecordSelect = false
        },

        // 获取库存数量
        async getStockNum() {
            if (!this.formData.record_id || !this.formData.apply_type) return

            this.currentStockNum = 0

            try {
                let detailRes
                if (this.formData.apply_type === 'product') {
                    detailRes = await studio_api.Teaching_studio_apiIotmaxProductDetailGet({
                        app_id: this.$root.app_id,
                        id: this.formData.record_id
                    })
                } else {
                    detailRes = await studio_api.Teaching_studio_apiIotmaxMaterialDetailGet({
                        app_id: this.$root.app_id,
                        id: this.formData.record_id
                    })
                }

                if (detailRes.errcode === 0 && detailRes.other) {
                    this.currentStockNum = detailRes.other.stock_num || 0
                }
            } catch (e) {
                console.error('获取库存失败', e)
            }
        },

        // 应用选择确认（表单用）
        onStudioConfirm2() {
            const picker = this.$refs.studioPicker2
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.formData.studio_id = item.value
                    // 提取名称，去掉 #ID 前缀
                    const nameMatch = item.text.match(/^#\d+\s*(.+)/)
                    this.formData.studio_name = nameMatch ? nameMatch[1] : item.text
                }
            }
            this.showStudioSelect2 = false
        },

        // 打开应用选择器
        onStudioSelect2Click() {
            this.filteredStudioList = [...this.studioList]
            this.studioSearchKey = ''
            this.showStudioSelect2 = true
        },

        // 打开设备选择弹窗
        openDeviceSelector() {
            this.refreshCurrentWarehouse()
            if (!this.formData.record_id) {
                this.$toast('请先选择产品')
                return
            }
            this.devicePage = 1
            this.deviceList = []
            this.deviceLoading = false
            this.deviceIsFetching = false
            this.deviceFinished = false
            this.deviceRefreshing = false
            this.selectedDeviceIds = this.selectedDevices.map(d => d.id)
            this.showDeviceSelector = true
            this.$nextTick(() => {
                this.loadDeviceList()
            })
        },

        // 加载设备列表
        async loadDeviceList() {
            if (this.deviceIsFetching || this.deviceFinished) return
            this.deviceIsFetching = true
            this.deviceLoading = true
            try {
                let params = {
                    app_id: this.$root.app_id,
                    product_id: parseInt(this.formData.record_id),
                    need_in_stock: 0,
                    page: this.devicePage,
                    page_size: this.devicePageSize
                }
                if (this.deviceFilter.device_sn) {
                    params.device_sn = this.deviceFilter.device_sn
                }
                if (this.deviceFilter.stock_in_time) {
                    params.stock_in_time = this.deviceFilter.stock_in_time
                }
                if (this.deviceFilter.stock_out_time) {
                    params.stock_out_time = this.deviceFilter.stock_out_time
                }
                let res = await studio_api.Teaching_studio_apiIotmaxProductDevice_listGet(params)
                if (res.errcode === 0 && res.other) {
                    const other = res.other || {}
                    const list = Array.isArray(other.list)
                        ? other.list
                        : (Array.isArray(other) ? other : [])
                    const total = Array.isArray(other)
                        ? list.length
                        : Number(other.total || 0)

                    if (this.devicePage === 1) {
                        this.deviceList = list
                    } else {
                        let newItems = list.filter(item => !this.deviceList.some(d => d.id === item.id))
                        this.deviceList = this.deviceList.concat(newItems)
                    }

                    if (!list.length || list.length < this.devicePageSize || (total > 0 && this.deviceList.length >= total)) {
                        this.deviceFinished = true
                    } else {
                        this.devicePage += 1
                    }
                } else {
                    this.deviceFinished = true
                }
            } catch (e) {
                console.error('加载设备列表失败', e)
                this.$toast('加载设备列表失败')
                this.deviceFinished = true
            } finally {
                this.deviceIsFetching = false
                this.deviceLoading = false
                this.deviceRefreshing = false
            }
        },

        // van-list 触发加载更多
        onDeviceLoad() {
            if (this.deviceFinished || this.deviceIsFetching) return
            this.loadDeviceList()
        },

        // 下拉刷新设备列表
        onDeviceRefresh() {
            this.devicePage = 1
            this.deviceList = []
            this.deviceFinished = false
            this.loadDeviceList()
        },

        // 搜索设备列表
        searchDeviceList() {
            this.devicePage = 1
            this.deviceList = []
            this.deviceFinished = false
            this.loadDeviceList()
        },

        // 重置设备筛选
        resetDeviceFilter() {
            this.deviceFilter = {
                device_sn: '',
                stock_in_time: 0,
                stock_in_time_text: '',
                stock_in_date: new Date(),
                stock_out_time: 0,
                stock_out_time_text: '',
                stock_out_date: new Date()
            }
            this.searchDeviceList()
        },

        // 入库时间确认
        onDeviceStockInDateConfirm(val) {
            this.deviceFilter.stock_in_time = Math.floor(val.getTime() / 1000)
            this.deviceFilter.stock_in_time_text = `${val.getFullYear()}-${(val.getMonth() + 1).toString().padStart(2, '0')}-${val.getDate().toString().padStart(2, '0')}`
            this.showDeviceStockInDatePicker = false
        },

        // 出库时间确认
        onDeviceStockOutDateConfirm(val) {
            this.deviceFilter.stock_out_time = Math.floor(val.getTime() / 1000)
            this.deviceFilter.stock_out_time_text = `${val.getFullYear()}-${(val.getMonth() + 1).toString().padStart(2, '0')}-${val.getDate().toString().padStart(2, '0')}`
            this.showDeviceStockOutDatePicker = false
        },

        // 切换设备选中状态
        toggleDevice(device) {
            if (!this.canSelectDevice(device)) {
                this.$toast("该设备出厂报告或出货报告不全，无法选择")
                return
            }
            const idx = this.selectedDeviceIds.indexOf(device.id)
            if (idx > -1) {
                this.selectedDeviceIds.splice(idx, 1)
            } else {
                this.selectedDeviceIds.push(device.id)
            }
        },

        // ??????
        confirmDeviceSelection() {
            this.selectedDevices = this.deviceList.filter(d => this.selectedDeviceIds.includes(d.id))
            const deviceTexts = this.selectedDevices.map(d => this.getSelectedDeviceText(d)).filter(Boolean)
            const sns = deviceTexts.join(',')
            this.formData.device_sns = sns
            this.formData.device_sns_display = sns || `已选${this.selectedDevices.length}台设备`
            // ?????????????
            this.formData.apply_num = String(this.selectedDevices.length)
            this.showDeviceSelector = false
        },

        // ??SN?????????
        onDeviceSnsInput() {
            const sns = this.formData.device_sns
            if (!sns || !sns.trim()) {
                this.formData.apply_num = ''
                return
            }
            const snList = sns.split(',').map(s => s.trim()).filter(Boolean)
            this.formData.apply_num = String(snList.length)
        },

        // 从URL中提取文件名
        getFileName(url) {
            if (!url) return ''
            try {
                let name = decodeURIComponent(url.split('/').pop().split('?')[0])
                if (name.length > 15) {
                    let ext = name.lastIndexOf('.') > -1 ? name.substring(name.lastIndexOf('.')) : ''
                    name = name.substring(0, 12) + '...' + ext
                }
                return name
            } catch (e) {
                return '已上传'
            }
        },

        // 下载报告
        downloadReport(url, name) {
            if (!url) {
                this.$toast('暂无报告文件')
                return
            }
            // 在H5环境直接打开URL下载
            window.open(url, '_blank')
        },

        // 提交表单
        async onSubmit() {
            // 验证必填项
            if (!this.formData.in_out) {
                this.$toast('请选择出入库')
                return
            }
            if (!this.formData.apply_type) {
                this.$toast('请选择类型')
                return
            }
            if (!this.formData.record_id) {
                this.$toast('请选择名称')
                return
            }
            // 产品类型必须填写设备SN
            if (this.formData.apply_type === 'product') {
                this.refreshCurrentWarehouse()
                if (this.formData.in_out === 'in') {
                    if (this.snInputMode === 'manual' && (!this.formData.device_sns || !this.formData.device_sns.trim())) {
                        this.$toast("请输入设备SN")
                        return
                    }
                } else if (this.formData.in_out === 'out') {
                    if (!this.formData.device_sns) {
                        this.$toast("请选择设备")
                        return
                    }
                }
            }
            if (!this.formData.apply_num) {
                this.$toast(this.formData.apply_type === 'product' && this.snInputMode === 'manual' ? '请填写设备SN以确定数量' : '请输入数量')
                return
            }
            if (parseInt(this.formData.apply_num) <= 0) {
                this.$toast('数量必须大于 0')
                return
            }
            // 获取 computer_code
            const computer_code = until.getCookie("guid").substring(0, 6) || Math.random().toString(36).substring(2, 8).toUpperCase()

            this.$toast.loading({ message: '获取 salt...', duration: 0 })

            try {
                // 先获取 salt
                let saltRes = await studio_tool_api.ToolForm_saltGet({
                    computer_code: computer_code
                })

                this.$toast.clear()

                if (saltRes.errcode !== 0 || !saltRes.other) {
                    this.$toast('获取 salt 失败')
                    return
                }

                const salt = saltRes.other

                // 如果是出库，需要检查库存
                if (this.formData.in_out === 'out') {
                    // 获取产品/物料详情检查库存
                    let detailRes
                    if (this.formData.apply_type === 'product') {
                        detailRes = await studio_api.Teaching_studio_apiIotmaxProductDetailGet({
                            app_id: this.$root.app_id,
                            id: this.formData.record_id
                        })
                    } else {
                        detailRes = await studio_api.Teaching_studio_apiIotmaxMaterialDetailGet({
                            app_id: this.$root.app_id,
                            id: this.formData.record_id
                        })
                    }

                    if (detailRes.errcode === 0 && detailRes.other) {
                        const stockNum = detailRes.other.stock_num || 0
                        if (stockNum < parseInt(this.formData.apply_num)) {
                            this.$toast(`库存不足，当前库存：${stockNum}`)
                            return
                        }
                    }
                }

                console.log('提交参数:', {
                    app_id: this.$root.app_id,
                    computer_code: computer_code,
                    salt: salt,
                    in_out: this.formData.in_out,
                    apply_type: this.formData.apply_type,
                    record_id: parseInt(this.formData.record_id),
                    apply_num: parseInt(this.formData.apply_num),
                    studio_id: parseInt(this.formData.studio_id) || 0,
                    remark: this.formData.remark || ''
                })

                this.$toast.loading({ message: '提交中...', duration: 0 })

                const submitParams = {
                    app_id: this.$root.app_id,
                    computer_code: computer_code,
                    salt: salt,
                    in_out: this.formData.in_out,
                    apply_type: this.formData.apply_type,
                    record_id: parseInt(this.formData.record_id),
                    apply_num: parseInt(this.formData.apply_num),
                    studio_id: parseInt(this.formData.studio_id) || 0,
                    device_sns: this.formData.device_sns || '',
                    auto_generate_sn: this.formData.apply_type === 'product' && this.formData.in_out === 'in' && this.snInputMode === 'auto' ? 1 : 0,
                    remark: this.formData.remark || ''
                }
                let res = this.formData.apply_type === 'product'
                    ? await createProductStockApply(submitParams)
                    : await studio_api.Teaching_studio_apiIotmaxStock_out_applyAddPost(submitParams)

                this.$toast.clear()

                if (res.errcode === 0) {
                    if (res.other && res.other.auto_generated_sn) {
                        this.generatedSns = String(res.other.device_sns || '').split(',').filter(Boolean)
                        this.generatedSnDialogVisible = this.generatedSns.length > 0
                        this.$toast.success('提交成功')
                    } else {
                        this.$toast.success('提交成功')
                    }
                    this.showAddForm = false
                    // 重置表单
                    this.formData = {
                        in_out: '',
                        in_out_text: '',
                        apply_type: '',
                        apply_type_text: '',
                        studio_id: '',
                        studio_name: '',
                        record_id: '',
                        record_name: '',
                        apply_num: '',
                        device_sns: '',
                        device_sns_display: '',
                        remark: ''
                    }
                    this.selectedDevices = []
                    this.selectedDeviceIds = []
                    this.snInputMode = 'manual'
                    this.currentStockNum = 0
                    // 刷新列表
                    this.onRefresh()
                } else {
                    this.$toast(res.errmsg || '提交失败')
                }
            } catch (e) {
                this.$toast.clear()
                console.error('提交失败', e)
                this.$toast('提交失败')
            }
        },

        // 显示详情 - 跳转到详情页
        showDetail(item) {
            this.$router.push({
                path: '/warehouse/record/detail',
                query: { id: item.id }
            })
        },

        // 判断是否有确认权限
        canConfirm(item) {
            // 超级管理员权限
            if (this.$root.isSuperRoot) {
                return true
            }
            // 检查用户权限
            if (this.$root.userInfo && this.$root.userInfo.stock_user_role) {
                const roleType = this.$root.userInfo.stock_user_role.role_type || ''
                const roles = roleType.split(',')
                return roles.includes('handle')
            }
            return false
        },

        // 确认出入库
        async confirmStock(item) {
            // 显示确认对话框
            const inOutText = item.in_out === 'in' ? '入库' : '出库'
            try {
                await this.$dialog.confirm({
                    title: '确认操作',
                    message: `确定要确认该${inOutText}记录吗？`,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
            } catch (e) {
                // 用户取消
                return
            }

            this.$toast.loading({ message: '确认中...', duration: 0 })

            try {
                // 获取 computer_code 和 salt
                const computer_code = until.getCookie("guid").substring(0, 6)
                
                let saltRes = await studio_tool_api.ToolForm_saltGet({
                    computer_code: computer_code
                })

                if (saltRes.errcode !== 0 || !saltRes.other) {
                    this.$toast.clear()
                    this.$toast('获取 salt 失败')
                    return
                }

                const salt = saltRes.other

                let res = await studio_api.Teaching_studio_apiIotmaxStock_out_applySurePut({
                    app_id: this.$root.app_id,
                    computer_code: computer_code,
                    salt: salt,
                    id: item.id
                })

                this.$toast.clear()

                if (res.errcode === 0) {
                    this.$toast.success('确认成功')
                    // 刷新列表
                    this.onRefresh()
                } else {
                    this.$toast(res.errmsg || '确认失败')
                }
            } catch (e) {
                this.$toast.clear()
                console.error('确认失败', e)
                this.$toast('确认失败')
            }
        },

        copyGeneratedSns() {
            until.copyToClipboard(this.generatedSns.join('\n')).then(() => {
                this.$toast.success('设备码已复制')
            }).catch(() => {
                this.$toast('复制失败，请长按文本手动复制')
            })
        },

        // 编辑项目
        editItem(item) {
            if (item.apply_type === 'product') {
                this.$toast('产品申请必须关联具体设备码，请删除后重新创建')
                return
            }
            // 打开编辑弹窗
            this.showEditForm = true
            this.editItemId = item.id
            // 加载详情数据
            this.loadEditDetail(item.id)
        },

        // 加载编辑详情
        async loadEditDetail(id) {
            this.$toast.loading({ message: '加载中...', duration: 0 })
            
            try {
                let res = await studio_api.Teaching_studio_apiIotmaxStock_out_applyDetailGet({
                    app_id: this.$root.app_id,
                    id: id
                })
                
                this.$toast.clear()
                
                if (res.errcode === 0 && res.other) {
                    const data = res.other
                    // 填充表单数据
                    this.editForm.in_out = data.in_out || ''
                    this.editForm.in_out_text = data.in_out === 'in' ? '入库' : (data.in_out === 'out' ? '出库' : '')
                    this.editForm.apply_type = data.apply_type || ''
                    this.editForm.apply_type_text = data.apply_type === 'product' ? '产品' : (data.apply_type === 'material' ? '物料' : '')
                    this.editForm.record_id = data.record_id || ''
                    this.editForm.record_name = data.record_name || ''
                    this.editForm.studio_id = data.studio_id || ''
                    this.editForm.studio_name = data.studio_name || ''
                    this.editForm.apply_num = data.apply_num || ''
                    this.editForm.remark = data.remark || ''
                } else {
                    this.$toast('加载详情失败')
                }
            } catch (e) {
                this.$toast.clear()
                console.error('加载详情失败', e)
                this.$toast('加载详情失败')
            }
        },

        // 编辑提交
        async onEditSubmit() {
            // 验证必填项
            if (!this.editForm.apply_type) {
                this.$toast('请选择类型')
                return
            }
            if (!this.editForm.record_id) {
                this.$toast('请选择名称')
                return
            }
            if (!this.editForm.apply_num || parseInt(this.editForm.apply_num) <= 0) {
                this.$toast('请输入有效数量')
                return
            }

            this.$toast.loading({ message: '保存中...', duration: 0 })

            try {
                // 获取 computer_code 和 salt
                const computer_code = until.getCookie("guid").substring(0, 6)
                
                let saltRes = await studio_tool_api.ToolForm_saltGet({
                    computer_code: computer_code
                })

                if (saltRes.errcode !== 0 || !saltRes.other) {
                    this.$toast.clear()
                    this.$toast('获取 salt 失败')
                    return
                }

                const salt = saltRes.other

                let res = await studio_api.Teaching_studio_apiIotmaxStock_out_applyUpdatePut({
                    app_id: this.$root.app_id,
                    computer_code: computer_code,
                    salt: salt,
                    id: this.editItemId,
                    in_out: this.editForm.in_out,  // 使用原始的 in_out 值
                    apply_type: this.editForm.apply_type,
                    record_id: parseInt(this.editForm.record_id),
                    apply_num: parseInt(this.editForm.apply_num),
                    studio_id: parseInt(this.editForm.studio_id),
                    remark: this.editForm.remark || ''
                })

                this.$toast.clear()

                if (res.errcode === 0) {
                    this.$toast.success('保存成功')
                    this.showEditForm = false
                    // 刷新列表
                    this.onRefresh()
                } else {
                    this.$toast(res.errmsg || '保存失败')
                }
            } catch (e) {
                this.$toast.clear()
                console.error('保存失败', e)
                this.$toast('保存失败')
            }
        },

        // 编辑 - 产品类型确认
        onEditApplyTypeConfirm() {
            const picker = this.$refs.editApplyTypePicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.editForm.apply_type = item.value
                    this.editForm.apply_type_text = item.text
                    // 清空之前的选择
                    this.editForm.record_id = ''
                    this.editForm.record_name = ''
                    // 加载对应的列表
                    this.getEditRecordList()
                }
            }
            this.showEditApplyTypeSelect = false
        },

        // 编辑 - 获取产品/物料列表
        async getEditRecordList() {
            if (!this.editForm.apply_type) return

            this.$toast.loading({ message: '加载中...', duration: 0 })

            try {
                let res
                if (this.editForm.apply_type === 'product') {
                    res = await studio_api.Teaching_studio_apiIotmaxProductListGet({
                        app_id: this.$root.app_id,
                        page: 1,
                        each_page: 100
                    })
                } else {
                    res = await studio_api.Teaching_studio_apiIotmaxMaterialListGet({
                        app_id: this.$root.app_id,
                        page: 1,
                        each_page: 100
                    })
                }

                this.$toast.clear()

                if (res.errcode === 0 && res.other) {
                    let listData = res.other.list || []
                    this.recordList = listData.map(item => ({
                        text: item.name,
                        value: String(item.id)
                    }))
                    this.filteredRecordList = [...this.recordList]
                    this.editRecordSearchKey = ''
                    this.showEditRecordSelect = true
                }
            } catch (e) {
                this.$toast.clear()
                console.error('获取列表失败', e)
                this.$toast('获取列表失败')
            }
        },

        // 编辑 - 过滤产品/物料列表
        filterEditRecordList() {
            if (!this.editRecordSearchKey) {
                this.filteredRecordList = [...this.recordList]
            } else {
                const key = this.editRecordSearchKey.toLowerCase()
                this.filteredRecordList = this.recordList.filter(item =>
                    item.text.toLowerCase().includes(key)
                )
            }
        },

        // 编辑 - 产品/物料选择确认
        onEditRecordConfirm() {
            const picker = this.$refs.editRecordPicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.editForm.record_id = item.value
                    this.editForm.record_name = item.text
                }
            }
            this.showEditRecordSelect = false
        },

        // 编辑 - 过滤项目列表
        filterEditStudioList() {
            if (!this.editStudioSearchKey) {
                this.filteredStudioList = [...this.studioList]
            } else {
                const key = this.editStudioSearchKey.toLowerCase()
                this.filteredStudioList = this.studioList.filter(item =>
                    item.text.toLowerCase().includes(key) ||
                    item.value.toLowerCase().includes(key)
                )
            }
        },

        // 编辑 - 项目选择确认
        onEditStudioConfirm() {
            const picker = this.$refs.editStudioPicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.editForm.studio_id = item.value
                    const nameMatch = item.text.match(/^#\d+\s*(.+)/)
                    this.editForm.studio_name = nameMatch ? nameMatch[1] : item.text
                }
            }
            this.showEditStudioSelect = false
        },

        // 删除项目
        async deleteItem(item) {
            try {
                await this.$dialog.confirm({
                    title: '确认删除',
                    message: '确定要删除这条出入库记录吗？'
                })
            } catch (e) {
                // 用户取消
                return
            }

            this.$toast.loading({ message: '删除中...', duration: 0 })

            try {
                let res = await studio_api.Teaching_studio_apiIotmaxStock_out_applyDelDelete({
                    app_id: this.$root.app_id,
                    id: item.id
                })

                this.$toast.clear()

                if (res.errcode === 0) {
                    this.$toast.success('删除成功')
                    // 刷新列表
                    this.onRefresh()
                } else {
                    this.$toast(res.errmsg || '删除失败')
                }
            } catch (e) {
                this.$toast.clear()
                console.error('删除失败', e)
                this.$toast('删除失败')
            }
        }
    }
}
</script>

<style scoped>
.stock_record {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    background: #F6F6F6;
}

.record_header {
    width: 100%;
    height: 88px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    box-sizing: border-box;
    position: sticky;
    top: 0;
    z-index: 100;
}

.van-tabs {
    background: transparent;
}

.list_container {
    height: calc(100vh - 88px - 44px);
    overflow-y: auto;
}

.back_btn i,
.header_filter i {
    font-size: 40px;
    color: #333;
}

.record_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
}

.record_list {
    padding: 20px;
    background: #F6F6F6;
}

.record_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 24px;
    background: #fff;
    border-radius: 16px;
    margin-bottom: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
}

.record_item:active {
    transform: scale(0.98);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.record_left {
    display: flex;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
}

.type_tag {
    width: 64px;
    height: 64px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    font-size: 26px;
    font-weight: 600;
    color: #fff;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.type_tag.in {
    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
}

.type_tag.out {
    background: linear-gradient(135deg, #FF5A4E 0%, #e53935 100%);
}

.record_info {
    flex: 1;
    min-width: 0;
}

.record_title {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.record_title .name {
    font-size: 28px;
    color: #333;
    font-weight: 600;
    word-break: break-all;
}

.record_meta {
    display: flex;
    align-items: center;
    font-size: 22px;
    color: #999;
    margin-top: 10px;
    flex-wrap: wrap;
}

.record_meta .divider {
    margin: 0 10px;
    color: #ddd;
}

.record_remark {
    font-size: 22px;
    color: #666;
    margin-top: 10px;
    background: #f9f9f9;
    padding: 8px 12px;
    border-radius: 6px;
    display: inline-block;
    max-width: 100%;
    word-break: break-all;
}

.record_right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    flex-shrink: 0;
}


.record_num {
    font-size: 32px;
    font-weight: 700;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.record_num.in {
    color: #4CAF50;
}

.record_num.out {
    color: #F44336;
}

.record_status {
    font-size: 20px;
    padding: 4px 12px;
    border-radius: 6px;
    font-weight: 500;
}

.record_status.status_0 {
    background: #FFF3E0;
    color: #FF9800;
}

.record_status.status_1 {
    background: #E8F5E9;
    color: #4CAF50;
}

.record_status.status_2 {
    background: #FFEBEE;
    color: #F44336;
}

.filter_panel {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.filter_header {
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    border-bottom: 1px solid #f0f0f0;
}

.filter_header span {
    font-size: 32px;
    font-weight: bold;
    color: #333;
}

.filter_header i {
    font-size: 36px;
    color: #999;
}

.filter_body {
    flex: 1;
    padding: 30px;
    overflow-y: auto;
}

.filter_section {
    margin-bottom: 40px;
}

.filter_title {
    font-size: 28px;
    color: #333;
    font-weight: bold;
    margin-bottom: 20px;
}

.filter_options {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.option {
    padding: 16px 40px;
    background: #f5f5f5;
    border-radius: 8px;
    font-size: 26px;
    color: #666;
}

.option.active {
    background: #E3F2FD;
    color: #2196F3;
}

.date_range {
    display: flex;
    align-items: center;
    gap: 20px;
}

.date_input {
    flex: 1;
    height: 72px;
    background: #f5f5f5;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    color: #666;
}

.filter_field {
    background: #f5f5f5;
    border-radius: 8px;
    margin-bottom: 20px;
}

.filter_footer {
    padding: 20px 30px;
    display: flex;
    gap: 20px;
    border-top: 1px solid #f0f0f0;
}

/* 选择器弹窗 */
.van-popup .van-picker {
    border-radius: 20px 20px 0 0;
}

.van-picker__toolbar {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.van-picker__toolbar button {
    font-size: 28px;
    font-weight: 500;
}

.van-picker__toolbar button:active {
    opacity: 0.8;
}

/* 新增按钮 */
.add_btn {
    position: fixed;
    right: 30px;
    bottom: 120px;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: #1989fa;
    box-shadow: 0 4px 12px rgba(25, 137, 250, 0.4);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
}

.add_btn:active {
    transform: scale(0.9);
    box-shadow: 0 2px 8px rgba(25, 137, 250, 0.3);
}

/* 新增表单弹窗 */
.add_form_panel {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
}

.form_header {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    border-bottom: 1px solid #f0f0f0;
}

.form_header span {
    font-size: 28px;
    font-weight: 600;
    color: #333;
}

.form_header i {
    font-size: 32px;
    color: #999;
}

.form_body {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    background: #F6F6F6;
}

.form_body .van-cell {
    background: #fff;
    margin-bottom: 12px;
    border-radius: 8px;
    padding: 12px 16px;
}

.form_body .van-field__label {
    font-size: 26px;
    font-weight: 500;
    color: #333;
    width: 100px;
}

.form_body .van-field__label .van-cell__label--required {
    color: #ee0a24;
}

.form_body .van-cell--required .van-cell__title::before {
    content: '*';
    color: #ee0a24;
    margin-right: 4px;
}

.form_body .van-field__control {
    font-size: 26px;
}

.submit_btn {
    margin-top: 24px;
    padding: 0 16px;
}

/* 选择器搜索样式 */
.picker_with_search {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.picker_with_search .van-search {
    padding: 10px 16px;
    background: #F6F6F6;
}

.picker_with_search .van-picker {
    flex: 1;
}

/* 库存提示 */
.stock_hint {
    padding: 12px 16px;
    background: #FFF3E0;
    color: #FF9800;
    font-size: 24px;
    margin: 8px 16px;
    border-radius: 8px;
    font-weight: 500;
}

.item_actions {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
}

/* 设备选择器样式 */
.device_selector_panel {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
}

.device_filter_area {
    padding: 10px 16px;
    background: #f9f9f9;
    border-bottom: 1px solid #eee;
}

.device_filter_area .van-cell {
    padding: 6px 12px;
    background: #fff;
    margin-bottom: 8px;
    border-radius: 6px;
}

.device_filter_btns {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 8px 0;
}

.device_list_area {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 80px;
}

.device_cell_title .device_sn {
    font-size: 28px;
    color: #333;
    font-weight: 500;
}

.device_cell_label {
    font-size: 22px;
    color: #999;
    margin-top: 4px;
}

.device_disabled {
    opacity: 0.5;
}

.device_no_report {
    font-size: 22px;
    color: #ee0a24;
    margin-left: 8px;
}

.report_missing {
    font-size: 22px;
    color: #ee0a24;
}

.device_list_empty {
    text-align: center;
    padding: 40px 0;
    color: #999;
    font-size: 26px;
}

.device_selector_footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 20px;
    background: #fff;
    border-top: 1px solid #eee;
    box-sizing: border-box;
}

.selected_devices_hint {
    padding: 8px 16px;
    background: #E3F2FD;
    color: #1976D2;
    font-size: 24px;
    margin: 4px 16px 8px;
    border-radius: 8px;
    font-weight: 500;
}

.generated_sn_result {
    padding: 20px 16px 8px;
}

.generated_sn_tip {
    margin-bottom: 12px;
    color: #07c160;
    font-size: 24px;
    line-height: 36px;
}

/* 报告操作区域 */
.device_report_actions {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed #eee;
}

.report_row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
}

.report_label {
    font-size: 22px;
    color: #666;
    min-width: 100px;
    flex-shrink: 0;
}

.report_file_name {
    font-size: 20px;
    color: #4E89FF;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

</style>
